import * as yup from "yup";

import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { IoSaveOutline } from "react-icons/io5";
import { FaCircleNotch } from "react-icons/fa";

import Textbox from "../../../../../components/common/Textbox";
import Toaster from "../../../../../components/common/Toaster";

import accountService from "../../../../../services/accountService";

const isValidURL = (url) => {
  try {
    new URL(url);
  } catch (ex) {
    return false;
  }
  return true;
};

const schema = yup.object({
  url: yup
    .string()
    .test("is-url-valid", "Please enter a valid URL", (value) =>
      isValidURL(value)
    )
    .required("Please enter a valid URL."),
});

const CloudStorageForm = ({ data, isLoading, setLoading, onSuccess }) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = async (item) => {
    try {
      setLoading(true);

      const account = { ...item };
      account["id"] = data.id;

      await accountService.saveCloudStorageURLAsync(account);

      setLoading(false);
      onSuccess(item.url);
      Toaster.Success("URL Saved Successfully!");
    } catch (ex) {
      Toaster.Error("Something went wrong.");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (data) {
      setValue("url", data.cloud_storage_url);
    }
  }, [data, setValue]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-8 space-y-6">
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <Textbox
            id="url-textbox"
            name="url"
            title="URL"
            type="text"
            register={register("url")}
            errors={errors}
          />
        </div>
      </div>
      <div className="grid grid-2 pt-2">
        <div className="col-span-2">
          <button
            type="submit"
            className="button button-primary disabled:opacity-70 disabled:cursor-not-allowed"
            disabled={isLoading}
          >
            {isLoading && <FaCircleNotch className="animate-spin mr-3" />}
            {!isLoading && <IoSaveOutline className="mr-3" />}
            Save Changes
          </button>
        </div>
      </div>
    </form>
  );
};

export default CloudStorageForm;
